import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import CurrencyUtils from '@/../bower_components/teknisavuecomponents/assets/utils/CurrencyUtils';
import Processo from '@/assets/ts/interfaces/Processo';
import AddCandidatoPopup from '../AddCandidatoPopup/AddCandidatoPopup.vue';

@Component({
  name: 'VagaCard',
  components: {
    AddCandidatoPopup,
  },
})
class VagaCard extends Vue {
  // #region [ PROPS ]
  @Prop({ default: {} })
  private readonly value: Processo;
  // #endregion

  // #region [ STORE ]
  // #endregion

  // #region [ EVENTS ]
  @Emit('click')
  private emitClick(): Processo {
    return Util.deepCopy(this.internalvalue);
  }

  @Emit('input')
  private emitInput(): Processo {
    return Util.deepCopy(this.internalvalue);
  }
  // #endregion

  // #region [ DATA ]
  private internalvalue: Processo = null;

  private clickInAction = false;

  private addCandidatoPopup = {
    show: false,
    nrProcesso: null as string,
  };
  // #endregion

  // #region [ COMPUTED ]
  public get salary(): string {
    const defaultDesc = 'R$???';
    const salary = this.internalvalue.VRSALARIO;

    if (!salary) {
      return defaultDesc;
    }

    if (Number.isNaN(parseFloat(salary))) {
      return salary;
    }

    const currencySalary = CurrencyUtils.numberToCurrency(salary);

    return currencySalary;
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true, deep: true })
  private valueOnChange(): void {
    if (!Util.deepCompare(this.value, this.internalvalue)) {
      this.internalvalue = Util.deepCopy(this.value);
    }
  }
  // #endregion

  // #region [ LIFECYCLE ]
  // #endregion

  // #region [ METHODS ]
  public cardOnClick(): void {
    if (this.clickInAction) {
      this.clickInAction = false;
      return;
    }

    this.emitClick();
  }

  public actionsOnClick(): void {
    //
  }

  public addCandidato(): void {
    this.clickInAction = true;

    this.addCandidatoPopup.show = true;
    this.addCandidatoPopup.nrProcesso = this.value.NRPROCESSO;
  }
  // #endregion
}

export default VagaCard;
